export const SLIPPAGE_WARNING = `Added amounts may be lower than displayed due to slippage, any differences will be refunded to wallet within the same transaction`;
